import { BaseRoutingContext } from "./BaseRoutingContext";
import { RoutingContext } from "./ReactRouter";

export function apiRoutesForContext(
    context: RoutingContext = new BaseRoutingContext(true),
) {
    return {
        server: {
            root: () => context.getApiBaseUrl()
        },
        auth: () => {
            return {
                login: () => "/Account/Token",
                register: () => "/Account/Registration",
                getEmailComfirmationUrl: () => "/Account/EmailConfirmation",
                forgotPassword: () => "/Account/ForgotPassword",
                resetPassword: () => "/Account/ResetPassword",
            };
        },
        profile: () => {
            return {
                changePassword: () => "/Account/ChangePassword",
                getUser: () => "/Users",
                updateUser: () => "/Users/update-by-current-user",

            };
        },
        superAdmin: () => {
            return {

                //user_managment
                createUser: () => "/Users",
                getUsers: () => "/Users",
                getUsersByOrganisationId: () => "/Users/organisationId",
                editUser: () => "/Users",
                deleteUser: () => "/Users",
                asignModule: () => "/UserModules",
                getUserModules: () => "/UserModules",
                approveRegistrationUser: () => "/Users/approve-registration",
                asignUserRole: () => "/Users",
            };
        },
        user: () => {
            return {
                executedActions: () => "/ExecutedActions",
            };
        },
        ticket: () => {
            return {
                getTickets: () => "/Tickets",
                getTicketsByOrganisation: () => "/Tickets/ByOrganisation",
                createTicket: () => "/Tickets",
                deleteTicket: () => "/Tickets",
                createFeedback: () => "/Tickets/Feedback",
                getTicketByTicketId: () => "/Tickets/ByTicketId",
                getFieldSettingsHeader: () => "/Tickets/FieldSettings",
                createFileByTicketId: () => "/Tickets/file",
            };
        },
        organisation: () => {
            return {
                getOrganisation: () => "/Organisations",
                getOrganisationsByUser: () => "/Organisations/ByUser",
                createOrganisation: () => "/Organisations",
                editOrganisation: () => "/Organisations",
                deleteOrganisation: () => "/Organisations",
                editFieldSetting: () => "/Organisations/FieldSetting",
            };
        },
    };
}
